import cx from "classnames"
import Icon from "src/shared/icons"
import { getCurrencyFormat } from "src/utils/string"
import { useAutoFontSize } from "../hooks/useAutoFontSize"

type CardProps = {
    image: string
    logo: string
    disponibles: number
    title: string
    hours: number
    size: number
    price: number
    priceBooking?: number
    priceExtra?: number
    maxExtra: number
    amenidades: string
    camas: string
    duracionReserva: number
    numeroCamas: number
}

function Card({
    image = "",
    logo = "",
    disponibles = 0,
    title = "",
    hours = 0,
    size = 0,
    price = 0,
    priceBooking = 0,
    priceExtra = 0,
    maxExtra = 0,
    camas = "",
    amenidades = "",
    duracionReserva = 0,
    numeroCamas = 0
}: CardProps): JSX.Element {
    const elemetos_estancia = [typeof priceBooking === "number", typeof priceExtra === "number", amenidades.length > 0].filter((v)=>v).length

    const {textRef, containerRef, fontSize } = useAutoFontSize({
        text: title,
        minFontSize: 12,
        maxFontSize: 34
    })

    return (
        <div className="disp__card">
            <div className="disp__card-info">
                <div className="disp__card-image">
                    {image ? (
                        <img className="disp__card-img" width={"100%"} height={"100%"} src={image} />
                    ) : logo ? (
                        <img height={62} src={logo} />
                    ) : (
                        <Icon name={"image"} height={116} width={116} color={"var(--drawer)"} />
                    )}
                </div>
                <div className="disp__card-base">
                    <div className="disp__card-name-section" ref={containerRef}>
                        <p className="disp__card-name" ref={textRef} style={{ fontSize }}>{title}</p>
                    </div>
                    <div
                        className="disp__card-state"
                        style={{ backgroundColor: disponibles > 0 ? "#10a31e" : "var(--ocupado)" }}
                    >
                        <p className="disp__card-state__value">{disponibles}</p>
                    </div>
                </div>
            </div>
            <div className="disp__card-row">
                <div className="disp__card-left">
                    <p className="disp__card-left-title">{"Tarifa vigente:"}</p>
                    <div className="disp__card-price__container disp__card-left-mb">
                        <Icon className="disp__icon-left" height={25} width={25} name={"coinMoney"} color={"var(--white-transparent)"} />
                        <p className="disp__card-price">
                            {getCurrencyFormat(price)}
                            <span className="disp__card-price-money">{"MXN"}</span>
                        </p>
                    </div>
                    <div className="disp__card-estancia-items disp__card-left-mb">
                        <div className="disp__card-item disp__card-item-space">
                            <Icon className="disp__icon-left" height={25} width={25} name={"Clock"} color={"var(--white-transparent)"} />
                            <span>{`${hours} h`}</span> 
                        </div>
                        <div className="disp__card-item">
                            <Icon className="disp__icon-left" height={25} width={25} name={"userFilled"} color={"var(--white-transparent)"} />
                            <span>{`${size} px`}</span>
                        </div>
                    </div>
                    {numeroCamas > 0 && (
                        <div className="disp__card-camas__container">
                            <Icon className="disp__icon-left" height={25} width={25} name={"BedFilled"} color={"var(--white-transparent)"} />
                            <p className={numeroCamas > 1 ? "disp__card-camas__label" : "disp__card-cama-unica__label"}>{camas}</p>
                        </div>
                    )}
                </div>
                {elemetos_estancia > 0 && (
                    <div className={cx("disp__card-right", elemetos_estancia < 3 ? "disp__card-right-pt" : "")}>
                        {typeof priceBooking === "number" && (
                            <div className="disp__card-description">
                                <Icon height={30} width={30} className="disp__icon-right" name={"calendarFill"} color={"var(--white-transparent)"} />
                                <div>
                                    <p className="disp__card-description-label">{"Reserva desde"}</p>
                                    <p className="disp__card-description-value">
                                        {getCurrencyFormat(priceBooking || 0)}
                                        <span className="disp__card-description-value-money">{"MXN"}</span>
                                        <span className="disp__card-description-value-extra">
                                            {/* Sin duración configurada (esta rama no tiene configuracion_estancia) se usa el texto de siempre */}
                                            {duracionReserva > 0 ? `(${duracionReserva}h)` : "(noche)"}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        )}
                        {typeof priceExtra === "number" &&  (
                            <div className="disp__card-description">
                                <Icon height={30} width={30} className="disp__icon-right" name={"userAdd"} color={"var(--white-transparent)"} />
                                <div>
                                    <p className="disp__card-description-label">{"Persona extra"}</p>
                                    <p className="disp__card-description-value">
                                        {getCurrencyFormat(priceExtra)}
                                        <span className="disp__card-description-value-money">{"MXN"}</span>
                                        <span className="disp__card-description-value-extra">{"(p/p)"}</span>
                                    </p>
                                </div>
                            </div>
                        )}
                        {amenidades && (
                            <div className="disp__card-description">
                                <div className="disp__icon-amenidades">
                                    <Icon className="disp__icon-right" height={30} width={17} name={"Toothbrush"} color={"var(--white-transparent)"} />
                                </div>
                                <p className="disp__card-amenidades__label">{amenidades}</p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default Card
